import React, { useEffect } from 'react'
import { BurnConfigType } from 'src/lib/types/rewards'
import InputTextField from 'src/components/common/form-elements/InputTextField'

interface BurnRuleDialogProps {
  initialBurnConfig: BurnConfigType
  burnConfig: BurnConfigType
  setBurnConfig: (values: BurnConfigType) => void
}

const BurnRuleDialog: React.FC<BurnRuleDialogProps> = ({ burnConfig, setBurnConfig, initialBurnConfig }) => {
  useEffect(() => {
    return setBurnConfig(initialBurnConfig)
  }, [])

  const handleEarnBurnConfigChange = (event: React.ChangeEvent<HTMLInputElement>, inputType: keyof BurnConfigType) => {
    if (!inputType || Number(event.target.value) > 100) return
    const enteredValue = event.target.value
    const obj: any = {}
    obj[inputType] = parseInt(enteredValue) < 0 ? 0 : parseInt(enteredValue)
    setBurnConfig({ ...obj })
  }

  return (
    <>
      <div className='flex flex-col items-start gap-4'>
        <div className='flex flex-col items-start justify-between w-full'>
          <p className='text-sm font-medium text-coal-light'>Burn allowed of order total</p>
          <InputTextField
            inputValue={burnConfig.burnRatio}
            textFieldId='burn-ratio'
            endIcon={<>%</>}
            inputType='number'
            handleChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              handleEarnBurnConfigChange(event, 'burnRatio')
            }}
            isFullWidth={true}
            customClass={'!w-1/2'}
          />
        </div>
      </div>
    </>
  )
}

export default BurnRuleDialog
